export function mapAuthErrorToMessage(error: unknown): string {
  if (!(error instanceof Error)) {
    return "Sign-in could not be completed. Please try again.";
  }

  const message = error.message.toLowerCase();

  if (message.includes("sso_storage_unavailable")) {
    return "Browser storage is required for SSO sign-in. Please disable private browsing or allow site storage, then try again.";
  }

  if (message.includes("auth_storage_failed")) {
    return "Cannot initialise authentication storage. Please disable private browsing or check browser storage settings.";
  }

  if (message.includes("tenant_not_configured")) {
    return "Sign-in could not be started. Please enter your email address and try again.";
  }

  if (message.includes("token") || message.includes("credential")) {
    return "Sign-in completed, but we could not verify your session. Please try again.";
  }

  return "Sign-in could not be completed. Please try again.";
}
